<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.guarantor}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtSalutation}}</v-subheader>
            <div>{{salutation}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtName}}</v-subheader>
            <div v-if="maid.gtName">{{maid.gtName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtNationality}}</v-subheader>
            <div>{{nationality}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtNric}}</v-subheader>
            <div v-if="maid.gtNric">{{maid.gtNric}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtDob}}</v-subheader>
            <div v-if="maid.gtDob">{{formatDisplayDate(maid.gtDob)}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtGender}}</v-subheader>
            <div>{{gender}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtOccupation}}</v-subheader>
            <div v-if="maid.gtOccupation">{{maid.gtOccupation}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtEmployerName}}</v-subheader>
            <div v-if="maid.gtEmployerName">{{maid.gtEmployerName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtEstAnnualIncome}}</v-subheader>
            <div v-if="maid.gtEstAnnualIncome">{{$store.state.agency.quotation.commonInfo.currPrefix}}{{formatDisplayNumber(maid.gtEstAnnualIncome)}}</div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.gtContact}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtEmail}}</v-subheader>
            <div v-if="maid.gtEmail">{{maid.gtEmail}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtMobileNo}}</v-subheader>
            <div v-if="maid.gtMobileNo">{{maid.gtMobileNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtTelNo1}}</v-subheader>
            <div v-if="maid.gtTelNo1">{{maid.gtTelNo1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.gtTelNo2}}</v-subheader>
            <div v-if="maid.gtTelNo2">{{maid.gtTelNo2}}</div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.gtAddress}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="maid.gtPostalCode">
              {{maid.gtAdd1}} {{maid.gtAdd2}} #{{maid.gtAdd3}} {{maid.gtAdd4}}, Singapore {{maid.gtPostalCode}}
            </div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { salutation, gender } from '@/const/underwriting'
import { gtNationality } from '@/const/underwriting/maid'

export default {
  data() {
    return {
      labels: {
        guarantor: 'Guarantor',
        gtSalutation: 'Salutation',
        gtName: 'Name as in NRIC',
        gtNationality: 'Nationality',
        gtNric: 'NRIC',
        gtDob: 'Date of Birth',
        gtGender: 'Gender',
        gtOccupation: 'Business/Profession',
        gtEmployerName: 'Name of Employer',
        gtEstAnnualIncome: 'Estimated Annual Income',
        gtContact: 'Contacts',
        gtEmail: 'Email',
        gtMobileNo: 'Mobile No.',
        gtTelNo1: 'Home No.',
        gtTelNo2: 'Office No',
        gtAddress: 'Guarantor Address'
      }
    }
  },
  computed: {
    maid() {
      return this.$store.state.agency.quotation.maidForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    salutation() {
      if (this.maid.gtSalutation) {
        return salutation[this.maid.gtSalutation]
      } else {
        return ' - '
      }
    },
    gender() {
      if (this.maid.gtGender) {
        return gender[this.maid.gtGender]
      } else {
        return ' - '
      }
    },
    nationality() {
      if (this.maid.gtNationality) {
        return gtNationality[this.maid.gtNationality]
      } else {
        return ' - '
      }
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  }
}
</script>

<style>
</style>
